export const emailSendingLoader = (state = false, action) => {
  switch (action.type) {
    case "SHOW_EMAIL_SENDING_LOADER_ADMIN":
      return true
    case "HIDE_EMAIL_SENDING_LOADER_ADMIN":
      return false
    default:
      return state
  }
}
